define('glu/poll',['require','./util'],function(require) {
    'use strict';

    var util = require('./util');

    return function(options, iteratorContext) {
        // Default the iterator context to `this` if not provided
        iteratorContext = iteratorContext || this;

        // Get options
        options = options || {};
        var iterator = options.iterator,
            limit = options.limit,
            onLimit = options.onLimit,
            onStop = options.onStop,
            immediateStart = options.immediateStart,
            interval = options.interval || 5000;

        // The callback the user invokes to stop polling
        var stop = util.bind(function() {
            if (this.timeout) {
                window.clearTimeout(this.timeout);
            }

            if (typeof onStop === 'function') {
                onStop();
            }
        }, this);

        // The callback the user invokes to poll again
        var poll = util.bind(function(timeout) {
            // If poll count limit is reach, then either stop silently, or invoke `onLimit` if provided.
            if (limit && this.count >= limit) {
                return (typeof onLimit === 'function') ? onLimit() : undefined;
            }

            // Queue up the next iteration
            var self = this;
            this.timeout = window.setTimeout(function() {
                self.count++;
                iterator.call(iteratorContext, poll, stop);
            }, (timeout || interval));
        }, this);

        if (immediateStart) {
            // Set up a poll counter, so that we can check if we've hit our limit
            this.count = 1;
            iterator.call(iteratorContext, poll, stop);
        }

        var self = this;

        return {
            // Starts or re-starts polling, always reseting the poll count back to 1.
            start: function() {
                // Set up a poll counter, so that we can check if we've hit our limit
                self.count = 1;
                iterator.call(iteratorContext, poll, stop);
            },

            // Alias of start
            restart: function() {
                // stop wipes the self pointer, repoint it to this
                self = this;
                this.start();
            },

            // Re-starts polling. The poll count remains as it was when the poll was paused.
            resume: function() {
                if (!self.count) {
                    throw new Error('You have not yet started this poll.');
                }
                iterator.call(iteratorContext, poll, stop);
            },

            pause: function() {
                if (self && self.timeout) {
                    window.clearTimeout(self.timeout);
                }
            },

            dispose: function() {
                stop();
            }
        };
    };
});

